import { render, staticRenderFns } from "./Bensadevot.vue?vue&type=template&id=1242f798"
import script from "./Bensadevot.vue?vue&type=script&lang=ts"
export * from "./Bensadevot.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports